var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMachines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 1.1C15 1.04477 14.9552 1 14.9 1H1.1C1.04477 1 1 1.04477 1 1.1V7.9C1 7.95523 1.04477 8 1.1 8H2.9C2.95523 8 3 8.04477 3 8.1V13.9434C3 13.9785 3.01843 14.0111 3.04855 14.0291L7.94855 16.9691C7.98022 16.9881 8.01978 16.9881 8.05145 16.9691L12.9514 14.0291C12.9816 14.0111 13 13.9785 13 13.9434V8.1C13 8.04477 13.0448 8 13.1 8H14.9C14.9552 8 15 7.95523 15 7.9V1.1Z",
    stroke: "#003393",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMachines);
export default __webpack_public_path__ + "static/media/machines.949cbb6f28097b1d1cd5aa8fba9a45ac.svg";
export { ForwardRef as ReactComponent };